import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { ManagedProduct } from '../../managed-macro-category';

export const mobileManagedColumns: Column<ManagedProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValueShort,
    key: 'equivalent',
    type: 'amount',
  },
];
